import React from 'react';
import { useNavigate } from 'react-router-dom';
import './TrialWarning.css';

const TrialWarning = ({ dagenOver }) => {
  const navigate = useNavigate();

  if (dagenOver === null || dagenOver === undefined || dagenOver > 3) {
    return null;
  }

  return (
    <div className={`trial-warning ${dagenOver === 0 ? 'expired' : ''}`}>
      <div className="trial-content">
        {dagenOver === 0 ? (
          <>
            <span className="trial-icon">⚠️</span>
            <span className="trial-text">
              <strong>Trial verlopen!</strong> Upgrade nu om toegang te behouden.
            </span>
          </>
        ) : (
          <>
            <span className="trial-icon">⏰</span>
            <span className="trial-text">
              <strong>Trial verloopt over {dagenOver} {dagenOver === 1 ? 'dag' : 'dagen'}!</strong>
            </span>
          </>
        )}
        <button onClick={() => navigate('/abonnementen')} className="btn-upgrade">
          ✨ Upgrade Nu
        </button>
      </div>
    </div>
  );
};

export default TrialWarning;
